import React from "react";
import { observer } from "mobx-react-lite";
import { Routes, Route } from "react-router-dom";
import { Layout } from "../../layout";
import { ConsoleContext } from "../../mobxStores/consoleContext/consoleContext";
import { IpSetList } from "./list";
import { IpSetCreate } from "./create";
import { IpSetDetailRoute } from "./detailRoute";

const IpSetRoute: React.FC = () => {
  const { org } = ConsoleContext;

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<IpSetList />} />
        <Route path={`-create/*`} element={<IpSetCreate />} />
        <Route path={`:ipset/*`} element={<IpSetDetailRoute />} />
      </Routes>
    </Layout>
  );
};

export default observer(IpSetRoute);
